import { registerAction } from '../../../Action'

const LOAD_CONTENT_PIECE = 'LOAD_CONTENT_PIECE'

const spliceInContent = (currentContent, newContentPiece) => {
  const index = currentContent.findIndex(
    (approval) => approval.id === newContentPiece.id
  )
  if (index > -1) {
    return currentContent.splice(index, 1, newContentPiece)
  }
  return [...currentContent, newContentPiece]
}

const reducer = (state = {}, action) => ({
  ...state,
  content: spliceInContent(state.content || [], action.payload),
})

const loadContentPiece = registerAction(LOAD_CONTENT_PIECE, { reducer })

export default loadContentPiece
